import { render, staticRenderFns } from "./VersionControlForm.vue?vue&type=template&id=38e5ddd0&"
import script from "./VersionControlForm.vue?vue&type=script&lang=js&"
export * from "./VersionControlForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports